<template>
  <v-tab-item>
    <v-layout justify-space-between>
      <v-flex md2>
        <v-btn dark color="primary" @click.stop="showTemplateDialog()"><v-icon dark>add</v-icon>{{ $t('template') }}</v-btn>
      </v-flex>
      <v-flex md2>
        <v-text-field
          append-icon="filter_list"
          class="text-xs-right"
          :label="$t('search')"
          single-line
          hide-details
          v-model="filter"
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="templateHeaders"
      :items="templates"
      item-key="key"
      class="my-1 levation-2 myDense"
      :rows-per-page-items="rowPerPage"
      :search="filter"
    >
      <template v-slot:items="props">
        <td class="text-xs-left">
          {{ props.item.name }}
        </td>
        <td class="text-xs-left">{{ props.item.from && props.item.from.fullName }}</td>
        <td class="text-xs-left" style="max-width: 30vw; word-break: break-all;">
          <v-layout row wrap>
            {{ props.item.sku }}
          </v-layout>
        </td>
        <td class="text-xs-left">
          <v-layout wrap v-if="props.item.note">
            <span class="font-weight-bold">{{ $t('note') }}:&nbsp; </span>{{ props.item.note }}
          </v-layout>
          <v-layout justify-space-between>
            <v-flex md6>
              <span class="font-weight-bold">{{ $t('Size(L/W/H)') }}: </span>{{displayPackaging(packagingMap.get(props.item.packaging) || props.item.packages[0])}}
            </v-flex>
            <v-flex md6>
              <span class="font-weight-bold">{{ $t('weight') }}: </span> {{ displayWeight(props.item) }}
            </v-flex>
          </v-layout>
          <v-layout  class="text-capitalize">
            <span class="font-weight-bold">{{ $t('signature') }}:&nbsp; </span> {{ props.item.signature }}
          </v-layout>
          <v-layout wrap v-if="props.item.memo">
            <span class="font-weight-bold">{{ $t('memo') }}:&nbsp; </span>{{ props.item.memo }}
          </v-layout>
        </td>
        <td class="text-xs-left">{{ props.item.shippingService }}</td>
        <td class="text-xs-left">{{ $t(props.item.isExpedited ? 'expedite' : 'normal') }}</td>
        <td class="text-xs-left">
          <v-chip v-for="item in props.item.selectedOtherServices" :key="item">
            {{ (otherServices.find(service => service.value.toLowerCase() === item.toLowerCase())||{}).displayName  || item}}
          </v-chip>
        </td>
        <td class="text-xs-center">
          <v-layout row>
            <v-flex>
              <v-btn
                dark
                flat
                color="primary"
                @click.stop="showTemplateDialog(props.item)"
              >{{ $t('edit') }}</v-btn>
            </v-flex>
            <v-flex>
              <v-btn
                dark
                flat
                color="primary"
                @click.stop="deleteTemplate(props.item)"
              >{{ $t('delete') }}</v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>

    <LabelTemplatePopup
      v-model="createTemplateDialog"
      v-if="createTemplateDialog"
      :initTemplate="templateInEdit"/>
  </v-tab-item>
</template>

<script>
import { mapGetters } from 'vuex'
import { measurementTools } from '@/utils/tools'
import LabelTemplatePopup from './LabelTemplatePopup.vue'

export default {
  name: 'TemplateAdmin',
  mixins: [measurementTools],
  components: {
    LabelTemplatePopup
  },
  data () {
    return {
      filter: '',
      rowPerPage: [15, 30, 50, {text: this.$t('all'), value: -1}],
      createTemplateDialog: false,
      templateInEdit: {},
      templateHeaders: [
        { text: this.$t('name'), value: 'name', align: 'left', sortable: false, width: '15%' },
        { text: this.$t('senderName'), value: 'sku', align: 'left', sortable: false },
        { text: 'Sku', value: 'sku', align: 'left', sortable: false, width: '30%' },
        { text: this.$t('details'), value: 'signature', align: 'left', sortable: false },
        { text: this.$t('serviceType'), value: 'serviceType', align: 'left', sortable: false },
        { text: this.$t('shippingService'), value: 'shippingService', align: 'left', sortable: false },
        { text: this.$t('otherServices'), value: 'selectedOtherServices', align: 'left', sortable: false },
        { text: this.$t('actions'), value: '', align: 'center', sortable: false, width: '10%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['templates', 'packagingMap', 'otherServices', 'isMeasurementMetric'])
  },
  methods: {
    showTemplateDialog (item = {}) {
      this.createTemplateDialog = true
      this.templateInEdit = item
    },
    deleteTemplate (item) {
      if (!confirm(this.$t('confirmDelete', { name: 'template' }))) return Promise.resolve()
      return this.$store.dispatch('deleteTemplate', item)
    },
    displayPackaging (packaging) {
      let {length, width, height, isMeasurementMetric, originLength, originWidth, originHeight, isPackagingDefault} = packaging || {}
      if (isPackagingDefault && !isMeasurementMetric) {
        const packageSizeInfo = this.convertPackagingSize({height, length, width}, isMeasurementMetric)
        return this.isMeasurementMetric ? `${packageSizeInfo.length}cm/${packageSizeInfo.width}cm/${packageSizeInfo.height}cm` : `${length || originLength}"/${width || originWidth}"/${height || originHeight}"`
      }
      return isMeasurementMetric ? `${originLength || length}cm/${originWidth || width}cm/${originHeight || height}cm` : `${length || originLength}"/${width || originWidth}"/${height || originHeight}"`
    },
    displayWeight (item) {
      const packageTemplateInfo = this.packagingMap.get(item.packaging) || item.packages[0] || {}
      if (packageTemplateInfo.isPackagingDefault) {
        return `${this.convertWeight(item.weightLb, item.isMeasurementMetric)}${this.isMeasurementMetric ? 'kg' : 'lbs'}`
      }
      return `${item.weightLb || packageTemplateInfo.weight}${item.isMeasurementMetric ? 'kg' : 'lbs'}`
    }
  }
}
</script>

<style scoped>
.myDense {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ShippingTemplateTab.vue